<div class="feedback-hints" [class.dark-background]="darkBackground()">
  @if (showUnseenActivityIcon()) {
    <div class="activity-icon">
      <app-svg src="/assets/icons/bolt.svg"></app-svg>
    </div>
  }

  @if (showFeedbackBar()) {
    <div class="feedback-bar">
      @if (showFavouriteIcon()) {
        <div class="has-span" [class.red]="is_liked()">
          @if (is_liked()) {
            <app-svg src="/assets/icons/heart-filled.svg"></app-svg>
          } @else {
            <app-svg src="/assets/icons/heart-empty.svg"></app-svg>
          }
          @if (likes()) {
            <span>{{ likes() }}</span>
          }
        </div>
      }
      @if (showStatusIcon()) {
        <div class="{{ status() | assetStatusColor }}">
          <app-svg [src]="'/assets/icons/' + (status() | assetStatusIcon) + '.svg'"></app-svg>
        </div>
      }
      @if (showColorLabelIcon()) {
        <div class="{{ color_label() }}">
          <app-svg src="/assets/icons/color-label-filled.svg"></app-svg>
        </div>
      }
      @if (showCommentIcon()) {
        <div class="has-span">
          <app-svg src="/assets/icons/comment-bubble.svg"></app-svg>
          <span>{{ commentThreadCount() }}</span>
        </div>
      }
    </div>
  }
</div>
